import { PageHeader, TabNav, TabNavItem } from "@nudgebox/ui";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { useOrgSlug } from "@/lib/params.ts";

const TABS = [
  { to: "/$orgSlug/settings", label: "Organization" },
  { to: "/$orgSlug/settings/account", label: "Account" },
] as const;

/** Shared header for the settings pages: organization-wide settings and the signed-in user's own. */
export function SettingsHeader({ description }: { description: string }) {
  const orgSlug = useOrgSlug();
  const matchRoute = useMatchRoute();
  const params = { orgSlug };

  return (
    <>
      <PageHeader title="Settings" description={description} />
      <TabNav aria-label="Settings">
        {TABS.map((tab) => (
          <TabNavItem
            key={tab.to}
            render={<Link to={tab.to} params={params} />}
            active={Boolean(matchRoute({ to: tab.to, params }))}
          >
            {tab.label}
          </TabNavItem>
        ))}
      </TabNav>
    </>
  );
}
